import TYPE from './types';

export function getElementType (element) {
  const elementType = Object.keys(TYPE).find(
    (type) => element && element.classList?.contains(TYPE[type])
  );

  return TYPE[elementType] || null;
}

export function isOfType (element) {
  return type => getElementType(element) === type;
}

export const isVideo = element => isOfType(element)(TYPE.Video);
export const isImage = element => isOfType(element)(TYPE.Image);
export const isSticker = element => isOfType(element)(TYPE.Sticker);
export const isLogo = element => isOfType(element)(TYPE.Logo);
export const isIcon = element => isOfType(element)(TYPE.Icon);

export const isQRCode = element => {
  return element.classList?.contains(TYPE.QRCode) || !!element.querySelector(TYPE.QRCode);
};

export const hasLayoutBox = element => {
  return element.classList?.contains('layoutBox') ?? false;
};

export const hasPlaceholderFrame = element => {
  return element.classList?.contains('placeholder-frame') ?? false;
};

export default function elementHelper (element) {
  return {
    getElementType: () => getElementType(element),
    hasLayoutBox: () => hasLayoutBox(element),
    hasPlaceholderFrame: () => hasPlaceholderFrame(element),
    isOfType: isOfType(element),
    isIcon: () => isIcon(element),
    isImage: () => isImage(element),
    isLogo: () => isLogo(element),
    isSticker: () => isSticker(element),
    isVideo: () => isVideo(element),
    isQRCode: () => isQRCode(element)
  };
}
